const carouselItems = [
  {
    title: '偶像练习生2026 — 年度最火选秀综艺',
    desc: '全新一季偶像练习生强势回归，百位练习生同台竞技，导师阵容全面升级。从初舞台到总决赛，全程高清收录，不缓冲不卡顿流畅播放。',
    tag: '重磅专题',
    img: 'https://readdy.ai/api/search-image?query=Grand%20flat%20design%20illustration%20of%20talent%20show%20stage%20with%20dramatic%20warm%20spotlights%20in%20coral%20and%20golden%20tones%2C%20large%20crowd%20silhouettes%2C%20minimalist%20geometric%20style%2C%20epic%20entertainment%20atmosphere%2C%20cinematic%20composition%2C%20clean%20abstract%20background&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    title: '爱豆团体综艺合集 — 200+偶像团体全覆盖',
    desc: '汇集国内外200+偶像团体的专属综艺内容，从日常vlog到舞台幕后，从团综真人秀到独家专访，一站式追星体验。每日更新，精彩不断。',
    tag: '独家合集',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20of%20multiple%20idol%20groups%20performing%20on%20colorful%20stages%2C%20warm%20coral%20and%20amber%20gradient%20lighting%2C%20minimalist%20design%2C%20abstract%20music%20and%20dance%20elements%2C%20clean%20geometric%20composition%2C%20entertainment%20broadcasting%20theme&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    title: '真人秀全季收录 — 从经典到最新一网打尽',
    desc: '户外挑战、恋爱观察、旅行体验、生存竞技……热门真人秀全季高清收录，从第一季到最新一季完整在线观看，不缓冲不卡顿，全集流畅播放。',
    tag: '全季收录',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20flat%20illustration%20of%20diverse%20reality%20show%20scenes%20including%20outdoor%20adventure%20and%20travel%2C%20warm%20golden%20hour%20lighting%20over%20minimalist%20landscapes%2C%20coral%20and%20amber%20gradients%2C%20clean%20geometric%20style%2C%20cinematic%20atmosphere&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    title: '高清音乐舞台纯享 — 沉浸式视听盛宴',
    desc: '偶像团体打歌舞台、年末颁奖典礼、回归舞台纯享版全收录。1080P高清画质搭配震撼音效，让您如临现场，感受偶像的每一个高光时刻。',
    tag: '视听盛宴',
    img: 'https://readdy.ai/api/search-image?query=Epic%20flat%20design%20illustration%20of%20grand%20music%20concert%20with%20massive%20colorful%20stage%20lighting%2C%20abstract%20audience%20silhouettes%2C%20warm%20coral%20and%20golden%20gradients%2C%20minimalist%20style%2C%20cinematic%20composition%2C%20clean%20geometric%20energy%20waves&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-3">
          重磅专题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          爱豆影视精选重磅专题内容，深度呈现偶像综艺魅力
        </p>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden cursor-pointer hover:border-primary-200 transition-all flex flex-col"
            >
              <div className="relative w-full aspect-[2/1] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={`爱豆影视 - ${item.title}`}
                  title={`爱豆影视${item.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-accent-500 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="text-base font-semibold text-foreground-800 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed flex-1">{item.desc}</p>
                <div className="flex items-center justify-end mt-4">
                  <span className="flex items-center gap-1 text-sm text-primary-600 font-medium whitespace-nowrap">
                    探索专题 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}